import * as exConstants from './constants';

import exPushMenuManager from './pushMenuManager';

// ----------------------------------------------------------------------------

function init(): void {
    app();
    toggle();
}

// ----------------------------------------------------------------------------

function app(): void {
    const sidebar = document.querySelector<HTMLElement>(exConstants.SELECTOR_APP_SIDEBAR) as HTMLElement | undefined;

    if (sidebar) {
        const data = new exPushMenuManager(sidebar);
        data.init();

        window.addEventListener('resize', (): any => {
            data.init();
        });
    }

    const sidebarOverlay = document.createElement('div');
    sidebarOverlay.className = exConstants.CLASS_NAME_SIDEBAR_OVERLAY;
    document.querySelector(exConstants.SELECTOR_APP_WRAPPER)?.append(sidebarOverlay);

    sidebarOverlay.addEventListener(
        'touchstart',
        (event): any => {
            event.preventDefault();
            const target = event.currentTarget as HTMLElement;
            const data = new exPushMenuManager(target);
            data.collapse();
        },
        { passive: true },
    );
    sidebarOverlay.addEventListener('click', (event): any => {
        event.preventDefault();
        const target = event.currentTarget as HTMLElement;
        const data = new exPushMenuManager(target);
        data.collapse();
    });
}

function toggle(): void {
    const elements = document.querySelectorAll<HTMLElement>(exConstants.SELECTOR_SIDEBAR_TOGGLE);

    for (const element of elements) {
        element.addEventListener('click', (event): any => {
            event.preventDefault();

            let button = event.currentTarget as HTMLElement | undefined;

            if (button?.dataset.lteToggle !== 'sidebar') {
                button = button?.closest(exConstants.SELECTOR_SIDEBAR_TOGGLE) as HTMLElement | undefined;
            }

            if (button) {
                event?.preventDefault();
                const data = new exPushMenuManager(button);
                data.toggle();
            }
        });
    }
}

// ----------------------------------------------------------------------------

export default init;
